export default __webpack_public_path__ + "static/media/checkbox_inactive_label.1938f253.svg";